import React from 'react';
import { Statistic, Skeleton } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingBag, faChartLine, faClock } from '@fortawesome/free-solid-svg-icons';
import { StatsGrid, StatCard, TitleIcon } from './styles';
import { addCommasInPrices } from './constants';
import type { OrderStatsSectionProps } from './types';

const OrderStatsSection: React.FC<OrderStatsSectionProps> = ({
  orders,
  totalRevenue,
  avgOrderValue,
  pendingCount,
  loading = false,
}) => (
  <StatsGrid>
    <StatCard>
      {loading ? (
        <Skeleton active paragraph={{ rows: 2 }} />
      ) : (
        <>
          <Statistic
            title="Total Orders"
            value={orders.length}
            suffix={
              <TitleIcon>
                <FontAwesomeIcon icon={faShoppingBag} />
              </TitleIcon>
            }
          />
          <span className="stat-help">Current period</span>
        </>
      )}
    </StatCard>
    <StatCard>
      {loading ? (
        <Skeleton active paragraph={{ rows: 2 }} />
      ) : (
        <>
          <Statistic
            title="Total Revenue"
            value={`$${addCommasInPrices(totalRevenue)}`}
          />
          <span className="stat-help">Current period</span>
        </>
      )}
    </StatCard>
    <StatCard>
      {loading ? (
        <Skeleton active paragraph={{ rows: 2 }} />
      ) : (
        <>
          <Statistic
            title="Avg Order Value"
            value={`$${addCommasInPrices(avgOrderValue)}`}
            suffix={
              <TitleIcon>
                <FontAwesomeIcon icon={faChartLine} />
              </TitleIcon>
            }
          />
          <span className="stat-help">Current period</span>
        </>
      )}
    </StatCard>
    <StatCard>
      {loading ? (
        <Skeleton active paragraph={{ rows: 2 }} />
      ) : (
        <>
          <Statistic
            title="Pending Orders"
            value={pendingCount}
            suffix={
              <TitleIcon>
                <FontAwesomeIcon icon={faClock} />
              </TitleIcon>
            }
          />
          <span className="stat-help">Requires attention</span>
        </>
      )}
    </StatCard>
  </StatsGrid>
);

export default OrderStatsSection;
